import React from 'react';

const Nosotros = () => (
  <div className="nosotros">
    <h1 className="section-title">Nosotros</h1>
    <div className="text-secondary mb-5">
      <p className="">Lyracons is an Argentinian software development company focused on eCommerce solutions with Magento & VTEX. We have vast expertise in complex, large-scale, B2C and B2B projects with CRM, ERP, Payment Gateways and OMS integrations.</p>
      <p className="">Lyracons provide full-service development, turn-key projects & off-shore elastics teams for Latin America & US market.</p>
      <p className="">We are the first and only New Relic partner & reseller in Argentina.</p>
    </div>
    <h2 className="section-title">Nuestras Redes</h2>
    { /* TODO: Agregar iconos de redes */ }
  </div>
);

export default Nosotros;